<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref, onMounted, onUnmounted } from 'vue'
import { useNavigation } from '@/presentation/composables/navigation/useNavigation.ts'
import { useAuthStore } from '@/presentation/stores/auth.ts'
import { storeEventBus } from '@/presentation/stores/utils/storeEventBus.ts'
import CNavMenuItem from './CNavMenuItem.vue'

// Props
defineProps<{
  isFullyOpened: boolean
}>()

// Store refs
const { isTeacher } = storeToRefs(useAuthStore())

// Menu data
const { menuItems, currentGroup } = useNavigation()
const loading = ref(false)

// Écouter les changements d'année scolaire active
function handleSchoolYearChange() {
  console.log('📅 Changement d\'année scolaire détecté dans menu')
  loading.value = true

  // Désactiver le loader après un court délai pour permettre aux données de se réinitialiser
  setTimeout(() => {
    loading.value = false
  }, 500)
}

// Monter le gestionnaire d'événements
onMounted(() => {
  storeEventBus.on('schoolYear:active:changed', handleSchoolYearChange)
})

// Nettoyer le gestionnaire d'événements
onUnmounted(() => {
  storeEventBus.off('schoolYear:active:changed', handleSchoolYearChange)
})
</script>

<template>
  <div
    class="_m-Lateral-Menu-Nav flex flex-col gap-6 px-6 py-2"
    :class="{ 'align-items-center': !isFullyOpened }"
  >
    <!-- Indicateur de chargement -->
    <div v-if="loading || !menuItems" class="my-2 flex justify-center">
      <i class="pi pi-spin pi-spinner text-primary" style="font-size: 1.5rem"></i>
    </div>

    <template v-else>
      <CNavMenuItem
        v-for="(item, i) in menuItems"
        :key="`link_${i}`"
        :item="item"
        :is-teacher="isTeacher"
        :is-fully-opened="isFullyOpened"
        :is-selected="currentGroup === item.group"
      />
    </template>
  </div>
</template>

<style scoped>
._m-Lateral-Menu-Nav {
  min-height: 200px;
}
</style>
